import apiService from "./apiService";

export const userService = {
    getUsers: (url, params) => apiService.get(url, params),
    getUser: (url) => apiService.get(url),
    addUser: (url, data) => apiService.post(url, data),
    updateUser: (url, data) => apiService.put(url, data),
    deleteUser: (url) => apiService.delete(url),
    authenticateUser: (url, data) => apiService.post(url, data),
}